import { waitTaskCompleted } from 'utils/asyncBackendTask/waitTaskCompleted';
import { postData } from 'utils/http/postData';

import { apiClientFetchS3UploadTask } from './apiFetchS3UploadTask';
import type { ApiPresignedFileUpload } from './types/ApiPresignedFileUpload';

type Args = {
  file: File;
  presignedUpload: ApiPresignedFileUpload;
};

export async function apiSendFileToS3PresignedUpload({
  file,
  presignedUpload,
}: Args) {
  // Prepare form data
  const formData = new FormData();
  for (const [key, value] of Object.entries(presignedUpload.params.fields)) {
    formData.append(key, value);
  }
  formData.append('file', file);

  // Send file
  await postData(presignedUpload.params.url, formData);

  // Wait for file to finish uploading
  const task = await apiClientFetchS3UploadTask(presignedUpload.s3File.id);
  await waitTaskCompleted(task);

  return presignedUpload.s3File.id;
}
